<template>
    <nav class="sidebar sidebar-offcanvas" id="sidebar">
        <ul class="nav">
            <li class="nav-item nav-profile">
                <a
                    @click="$router.push({ name: 'account.info' })"
                    class="cursor-pointer noselect nav-link"
                    v-if="$store.getters.user !== null"
                >
                    <div
                        class="nav-profile-text d-flex flex-column ellipsis ml-0"
                    >
                        <div class="mb-2">
                            <span class="font-weight-bold">{{
                                $store.getters.user.first_name
                            }}</span>
                            <span
                                class="font-weight-bold"
                                :class="{ 'd-block': longName }"
                                >{{ $store.getters.user.last_name }}</span
                            >
                        </div>
                        <small class="text-muted">{{ getGreeting }}</small>
                    </div>
                </a>
            </li>

            <li
                class="nav-item"
                v-for="link in sidebarLinks"
                v-if="canSeeLink(link)"
                :class="{ 'active': isActive(link) }"
            >
                <!-- Nav Item with normal link -->
                <div
                    v-if="
                        typeof link.items === 'undefined' || !link.items.length
                    "
                >
                    <router-link
                        tag="a"
                        class="nav-link btn btn-outline-dark btn-block mb-3 pl-3 pr-1"
                        :to="{ name: link.routeName }"
                    >
                        <span class="menu-title oswald">{{ link.label }}</span>
                    </router-link>
                </div>

                <!-- Nav Item that collapses -->
                <div v-else>
                    <a
                        class="nav-link cursor-pointer btn btn-outline-dark mb-3 pl-3 pr-1"
                        @click="
                            link.show = typeof link.show === 'undefined' ? true : !link.show;
                            typeof link.routeDef === 'undefined' ? null : $router.push(link.routeDef);
                        "
                    >
                        <span class="menu-title oswald">{{ link.label }}</span>
                    </a>
                    <div
                        class="collapse"
                        :class="{
                            show: typeof link.show !== 'undefined' && link.show
                        }"
                    >
                        <ul class="nav flex-column sub-menu">
                            <li
                                class="nav-item cursor-pointer"
                                v-for="subItem in link.items"
                            >
                                <a
                                    class="nav-link oswald"
                                    @click="$router.push(subItem.routeDef)"
                                >
                                    {{ subItem.label }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
        </ul>
    </nav>
</template>

<script>
import VideoSeriesRepository from "../../../repositories/Gym/VideoSeriesRepository";

export default {
    name: "DashboardSidebar",
    data: () => ({
        sidebarLinks: [],
        series: [],
    }),
    mounted() {
        this.$i18n.locale = this.$store.state.language;
        this.sidebarLinks = [
            {
                label: this.$t("live.page_title"),
                icon: "mdi-record-circle-outline text-danger font-weight-bold",
                routeName: "gym.live",
                requiresSubscription: true,
                condition: this.$store.getters.isLiveStreamOnline
            },
            {
                label: this.$t("pages.locker.title"),
                icon: "mdi-google-classroom",
                routeName: "locker.get-aform",
                requiresSubscription: true,
                activeWord: 'locker-room'
            },
            {
                label: this.$t("pages.gym.title"),
                icon: "mdi-dumbbell",
                routeName: "gym.index",
                requiresSubscription: true
            },
            {
                label: this.$t("pages.account.title"),
                icon: "mdi-account",
                routeName: "account.info",
                requiresSubscription: false
            },
            {
                label: this.$t("pages.admin.title"),
                icon: "mdi-account-tie",
                show: false,
                requiresAdmin: true,
                items: [
                    {
                        routeDef: { name: "admin.video.index" },
                        label: this.$t("pages.admin.video.title")
                    },
                    {
                        routeDef: { name: "admin.series.index" },
                        label: this.$t("pages.admin.series.title")
                    },
                    {
                        routeDef: { name: "admin.blog.index" },
                        label: this.$t("pages.admin.blog.index.title")
                    },
                    {
                        routeDef: { name: "admin.messages.send" },
                        label: this.$t("pages.admin.messages.title")
                    },
                    {
                        routeDef: { name: "admin.faq.index" },
                        label: this.$t("pages.admin.faq.index.title")
                    },
                    {
                        routeDef: {
                            name: "admin.livestream.announcement.index"
                        },
                        label: this.$t(
                            "pages.admin.livestream.announcements.index.title"
                        )
                    },
                    {
                        routeDef: { name: "admin.user.index" },
                        label: this.$t("pages.admin.users.title")
                    },
                    {
                        routeDef: { name: "admin.orders.index" },
                        label: this.$t("pages.admin.equipment_order.title")
                    }
                ]
            }
        ];

        if (this.isSubscribed)
            this.getVideoSeries();
    },
    methods: {
        canSeeLink(link) {
            let canSee = true;

            if (link.requiresSubscription && !this.$store.getters.isSubscribed)
                canSee = false;

            if (link.requiresAdmin && !this.$store.getters.isAdmin)
                canSee = false;

            if (link.condition !== undefined && !link.condition) canSee = false;

            return canSee;
        },

        isActive(link) {
            if(link.activeWord !== undefined) {
                return this.$route.name.includes(link.activeWord);
            }

            return this.$route.name === link.routeName || this.$route.name.startsWith(link.routeName);
        },

        getVideoSeries() {
            VideoSeriesRepository.getSeriesForSidebar().then(res => {
                this.series = res.data;

                let sideBarItem = {
                    label: this.$t("pages.series.title"),
                    icon: "mdi-television",
                    show: false,
                    requiresSubscription: true,
                    requiresAdmin: false,
                    routeDef: { name: "series.index" },
                    items: [
                        {
                            routeDef: { name: "series.index" },
                            label: this.$t("pages.series.index.all")
                        }
                    ]
                };

                if (this.series.length) {
                    this.series.forEach(series =>
                        sideBarItem.items.push({
                            routeDef: {
                                name: "series.show",
                                params: { slug: series.slug }
                            },
                            label: series.title["en"]
                        })
                    );
                }

                // add after gym.
                this.sidebarLinks.splice(3, 0, sideBarItem);
            });
        }
    },
    watch: {
        isSubscribed: function(val) {
            if (val) {
                this.getVideoSeries();
            } else {
                this.series = [];
            }
        },

    },
    computed: {
        isSubscribed() {
            return this.$store.getters.isSubscribed;
        },
        getGreeting() {
            let today = new Date();
            let currentHour = today.getHours();

            if (currentHour < 12) return this.$t("sidebar.greetings.morning");
            else if (currentHour < 18)
                return this.$t("sidebar.greetings.afternoon");

            return this.$t("sidebar.greetings.evening");
        },
        longName() {
            return this.$store.getters.user.last_name.length + this.$store.getters.user.first_name.length > 24;
        }
    }
};
</script>

<style scoped></style>
